//Libs
import { useContext } from 'react'
import styled from 'styled-components'

// Comps
import { Context as ModalsContext } from '../../context/Modals'

// Defs
interface Props {
  onClick?: () => void
  className?: string
}

// Styles
const ContainerButton = styled.button`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  border-radius: 100px;

  svg {
    /* IOS fix */
    flex-shrink: 0;
    flex-grow: 0;
    /* Correct color */
    opacity: 0.3;
  }
`
export const CloseIconSVG = () => {
  // ..
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 6L6 18"
        stroke="#2C2D35"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="#2C2D35"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ModalCloseButton: React.FC<Props> = (props) => {
  // Props
  const { onClick, className } = props

  // Global State
  const { modalSearchClass } = useContext(ModalsContext)

  // funcs
  const theOnCLick = () => {
    if (onClick) {
      onClick()
    } else {
      console.warn('@ModalCloseButton->onClick not set')
    }
  }

  // ..
  return (
    <ContainerButton
      className={`ModalCloseButton ${className || ''} ${modalSearchClass}`}
      onClick={theOnCLick}>
      <CloseIconSVG />
    </ContainerButton>
  )
}
